<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'sbRateEdit',
    components: {
      baseEdit,
    },
  };
</script>
